import { Injectable } from "@angular/core";
import { saveAs } from 'file-saver';
import { NomiDescrittoriSezione } from '../configuration/nomi-descrittori-sezione';
import { DescrittoriSezioneHash } from '../interface/descrittori-sezione-hash';
import { DescrittoreSezione } from '../models/descrittore-sezione';
import { NumericOperationManager } from "./numeric-operation-manager";

@Injectable()
export class UtilityCommon {

  static formattaOra(ora: string): string {
    if (ora) {
      let sep = ':';
      let hh_ora = ora.split(sep)[0];
      let mm_ora = ora.split(sep)[1];
      if (hh_ora && hh_ora.length === 1) {
        hh_ora = '0' + hh_ora;
      }
      if (mm_ora && mm_ora.length === 1) {
        mm_ora = '0' + mm_ora;
      }
      ora = hh_ora + sep + mm_ora;
    }
    return ora;
  }

  static orderBy(value: Array<any>, attrValueOrder: string): any {
    if (value) {
      return attrValueOrder ?
        value.sort((a, b) => {
          let attrsValue: string[] = attrValueOrder.substr(0, attrValueOrder.indexOf(':')).split('+');
          let typeOrder = attrValueOrder.substr(attrValueOrder.indexOf(':') + 1);
          let orderA: any;
          let orderB: any;
          let finishedOrderA = false;
          let finishedOrderB = false;

          for (let path of attrsValue) {
            let appA = a;
            let appB = b;
            let someArray = path.split('.');
            for (let entry of someArray) {
              if (appA) {
                appA = appA[entry];
              }
              if (appB) {
                appB = appB[entry];
              }
            }

            if (appA && !finishedOrderA) {
              if (!orderA) {
                orderA = appA;
              } else {
                orderA = orderA + appA;
              }
            } else {
              finishedOrderA = true;
            }

            if (appB && !finishedOrderB) {
              if (!orderB) {
                orderB = appB;
              } else {
                orderB = orderB + appB;
              }
            } else {
              finishedOrderB = true;
            }
          }

          if (!orderA) {
            return 1;
          }

          if (!orderB) {
            return -1;
          }


          if (typeOrder === 'ASC') {
            if (typeof orderA === 'string') {
              return (orderA.toLowerCase() < orderB.toLowerCase()) ? -1 : (orderA.toLowerCase() > orderB.toLowerCase()) ? 1 : 0;
            } else {
              return (orderA < orderB) ? -1 : (orderA > orderB) ? 1 : 0;
            }
          }
          if (typeOrder === 'DESC') {
            if (typeof orderA === 'string') {
              return (orderA.toLowerCase() < orderB.toLowerCase()) ? 1 : (orderA.toLowerCase() > orderB.toLowerCase()) ? -1 : 0;
            } else {
              return (orderA < orderB) ? 1 : (orderA > orderB) ? -1 : 0;
            }
          }
        })
        : value;
    } else {
      return value;
    }
  }

  public static createHashMapDescrittoriFascicolo(arrayDescrittori: DescrittoreSezione[]): DescrittoriSezioneHash {

    let map: DescrittoriSezioneHash = new DescrittoriSezioneHash();
    for (let descrittore of arrayDescrittori) {
      if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_DEFINIZIONE ||
          descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_RIMOZIONE_DEFINIZIONE ||
          descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_RIUNIONE_GIUDIZI ||
          descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_CANCELLAZIONE ||
          descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_ESTRAZIONE ||
          descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_PCT_CONSULTAZIONE ||
          descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_PCT_DEPOSITO ||
          descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_RIMOZIONE_RIUNIONE_GIUDIZI ||
          descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_COPIA_FASCICOLO ||
          descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_GENERAZIONE_DOCUMENTO) {
        map[descrittore.entitySimpleName] = descrittore;
      }
    }
    return map;
  }

  public static loadScript(url) {
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
 }

 public static sanitizeString(str) {
   return str.replace(/[&\/\\#,+()$~%.'":;*?<>{}\s]/g, '');
 }

 public static downloadFile(value) {
    // Conversione per evitare che la trasformazione diretta da byte[] a Blob corrompa il file
    const byteCharacters = atob(value.streamData);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/octet-stream"
    });

    const fileName = value.nome.concat('_Template.rtf');
    try {
      saveAs(blob, fileName);
    } catch (err) {
      window.navigator.msSaveBlob(blob, fileName);
    }
  }

 public static hideGroupAssegnazioneCompetenza(tipoFascicolo) {
  const tipiFascicoliHideGroupArray = [{
    endpoint: 'disciplina'
  }, {
    endpoint: 'altrerisoluzionilavoro'
  }, {
    endpoint: 'accessoagliatti'
  }, {
    endpoint: 'opposaiserviziispettivi'
  }, {
    endpoint: 'amianto'
  }, {
    endpoint: 'amiantogiudiziale'
  }];
  return !!tipiFascicoliHideGroupArray.find(el => el.endpoint === tipoFascicolo);
 }

  public static calcolaSomma(valori: any[]) {
    let sommaOttenuta: string = NumericOperationManager.getSum(valori);
    let segno = false;
    if (sommaOttenuta.substring(0, 1) === '-') {
      sommaOttenuta = sommaOttenuta.substring(1);
      segno = true;
    }
    let indexVirgola: number = sommaOttenuta.indexOf(',');
    if (indexVirgola === -1 ) {
      indexVirgola = sommaOttenuta.length;
    }
    indexVirgola = indexVirgola - 3;
    while (indexVirgola > 0) {
      sommaOttenuta = sommaOttenuta.substring(0, indexVirgola) + '.' + sommaOttenuta.substring(indexVirgola);
      indexVirgola = indexVirgola - 3;
    }
    if (segno) {
      sommaOttenuta = '-' + sommaOttenuta;
    }
    return sommaOttenuta;
  }

  public static toQueryParams(path: string, request: object) {
    const params = new URLSearchParams();

    Object.entries(request).forEach(it => {
      params.append(it[0], (it[1] as any).toString())
    });

    return (
      path + (
        params.toString().length === 0
          ? ""
          : "?" + params.toString()
      )
    )
  }
}

